
import React from "react";
import { useTranslation } from "react-i18next";

const SelectTimeDescription: React.FC = () => {
  const { t } = useTranslation('booking');
  return (
    <p className="text-foreground/50 text-sm mb-6 text-center">
      {t('TIME_SUBTITLE')}
    </p>
  );
};

export default React.memo(SelectTimeDescription);
